module.exports = __webpack_public_path__ + "static/media/album_cover_ballads.0c1cdf7f.png";